import React, { useEffect, useState } from 'react';
import { Observer } from 'mobx-react';
import {
  Button,
  Typography,
  TextField,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import { useParams, useHistory } from 'react-router-dom';
import { Formik } from 'formik';
import { css } from '@emotion/core';
import { useRootStore } from '../../../stores/BridgeProvider';
import Spinner from '../../util/Spinner';
import { FlexDiv, WideBox, StyledForm } from '../../styles/styles';
import { safeEval } from '../../util/UtilFunctions';

const AccountInfo = () => {
  return (
    <Observer
      render={() => {
        const { accountId } = useParams();
        const history = useHistory();
        const { authStore, dataStore, orgStore } = useRootStore();
        const [isLoading, setLoading] = useState(true);
        const [account, setAccount] = useState(null);
        const [accountTypes, setAccountTypes] = useState([]);

        const { settings } = orgStore;

        const { ExtSysId } = settings;

        const fetchAccountTypes = async () => {
          try {
            const { data } = await authStore.request.get(
              `${process.env.REACT_APP_API}/api/account-types`,
            );
            setAccountTypes(data);
          } catch (e) {
            console.error(e);
          }
        };
        const fetchAccount = async () => {
          try {
            const { data } = await authStore.request.get(
              `${process.env.REACT_APP_API}/api/account/${accountId}`,
            );
            setAccount(data);
          } catch (e) {
            console.error(e);
          }
        };
        useEffect(() => {
          const initialActions = async () => {
            await Promise.all([fetchAccount(), fetchAccountTypes()]);
            setLoading(false);
          };
          initialActions();
        }, []);
        if (isLoading || !account) return <Spinner />;

        return (
          <FlexDiv>
            <Formik
              initialValues={{
                accountId: account.AccountId,
                accountCode: account.AccountCode,
                accountName: account.AccountName,
                type: account.TypeId,
                statusId: account.StatusId,
                bankAccountType: account.BankAccountType,
              }}
              onSubmit={async (values, actions) => {
                try {
                  await authStore.request.post(
                    `${process.env.REACT_APP_API}/api/account/`,
                    {
                      ...values,
                    },
                  );
                  await dataStore.retrieveAccounts();
                  history.push('/accounts');
                } catch (e) {
                  console.error(e);
                  actions.setSubmitting(false);
                }
              }}
              render={({
                handleBlur,
                handleChange,
                errors,
                handleSubmit,
                values,
                isSubmitting,
                dirty,
                setFieldValue,
              }) => {
                return (
                  <WideBox>
                    <Typography variant="h2" gutterBottom>
                      Edit Account
                    </Typography>
                    <StyledForm onSubmit={handleSubmit}>
                      <TextField
                        name="accountName"
                        label="Account Name"
                        value={values.accountName}
                        margin="normal"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        variant="outlined"
                        fullWidth
                        error={errors.accountName}
                      />
                      <TextField
                        name="accountCode"
                        label="Account Code"
                        value={values.accountCode}
                        margin="normal"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        variant="outlined"
                        fullWidth
                        error={errors.accountCode}
                      />
                      <TextField
                        name="accountType"
                        label="Account Type"
                        value={safeEval(
                          () =>
                            accountTypes.find(
                              ({ AccountTypeId }) =>
                                AccountTypeId === values.type,
                            ).Name,
                          'Not found',
                        )}
                        margin="normal"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        variant="outlined"
                        fullWidth
                        disabled
                      />
                      <TextField
                        name="bankAccountType"
                        label="Bank Account Type"
                        value={values.bankAccountType}
                        margin="normal"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        variant="outlined"
                        fullWidth
                        disabled={ExtSysId !== 0}
                      />
                      <div>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={!!values.statusId}
                              onChange={(e, val) => {
                                setFieldValue('statusId', val);
                              }}
                              value={values.statusId}
                            />
                          }
                          label="Visible"
                        />
                      </div>

                      <div
                        css={css`
                          display: flex;
                          margin-top: 1.2rem;
                          justify-content: flex-end;
                          & > button,
                          a {
                            margin: 5px;
                          }
                        `}
                      >
                        <Button
                          color="primary"
                          variant="contained"
                          type="submit"
                          size="large"
                          disabled={!dirty || isSubmitting}
                        >
                          Submit
                        </Button>
                        <Button
                          color="secondary"
                          variant="outlined"
                          size="large"
                          onClick={() => history.goBack()}
                        >
                          Cancel
                        </Button>
                      </div>
                    </StyledForm>
                  </WideBox>
                );
              }}
            />
          </FlexDiv>
        );
      }}
    />
  );
};

export default AccountInfo;
